var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tablePage" }, [
    _c("div", { staticClass: "page_header" }, [
      _c("div", { staticClass: "page_header_search" }, [_vm._t("search")], 2),
      _c(
        "div",
        { staticClass: "page_header_action" },
        [_vm._t("headerLeft"), _vm._t("headerRight")],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "page_content", attrs: { id: "page_content" } },
      [
        _c(
          "MTable",
          _vm._g(
            _vm._b(
              {
                ref: "mTable",
                attrs: {
                  "table-data": _vm.tableData,
                  checkbox: _vm.checkbox,
                  border: _vm.border,
                  "if-index": _vm.ifIndex,
                  loading: _vm.loading,
                  "table-columns": _vm.tableColumns,
                },
                on: { "selection-change": _vm.handleSelectionChange },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.slotArr, function (item, i) {
                      return {
                        key: item,
                        fn: function (text, record, index) {
                          return [
                            _c(
                              "span",
                              { key: `${item}-${i}` },
                              [
                                _vm._t(item, null, {
                                  row: text.row,
                                  record: record,
                                  index: index,
                                }),
                              ],
                              2
                            ),
                          ]
                        },
                      }
                    }),
                  ],
                  null,
                  true
                ),
              },
              "MTable",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "page_footer" },
      [
        _vm._t("footer"),
        !_vm.hidePagination
          ? _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": _vm.pageSizes,
                "page-size": _vm.pageSize,
                layout: _vm.layout,
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            })
          : _vm._e(),
        _vm._t("footerRight"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }